import React, { useState, useEffect } from 'react';
import { Grid, Typography, CircularProgress, Box, Dialog, DialogContent, IconButton } from '@mui/material';
import TextInputs from 'src/components/inputs/TextInputs';
import { Button } from 'reactstrap';
import { useMain } from 'src/views/hooks/useMain';
import { MdClose } from 'react-icons/md';
import { FaWhatsapp, FaEye, FaEyeSlash } from 'react-icons/fa';

const WhatsAppIntegration = ({ data, refreshData }) => {
  const { setShowMessage, updateMsg91Whatsapp, updateMsg91Whatsapptemplatenames, getWhatsappSettings, resetWhatsappSettings } = useMain();
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    authKey: '',
    integrationNumber: '91',
    namespace: '',
    whatsappApiUrl: '',
    billing: '',
    appointment: '',
    appointmentReminder: '',
    birthday: '',
    anniversary: '',
    serviceReminder: '',
  });
  const [loading, setLoading] = useState(false);
  const [showAuthKey, setShowAuthKey] = useState(false);
  const [showIntegrationNumber, setShowIntegrationNumber] = useState(false);
  const [showNamespace, setShowNamespace] = useState(false);
  const [showApiUrl, setShowApiUrl] = useState(false);

  useEffect(() => {
    if (open && data?._id) {
      const fetchSettings = async () => {
        try {
          const res = await getWhatsappSettings(data._id);
          if (res?.statusCode === 200 || res?.success === true) {
            const apiData = res.data;
            setFormData({
              authKey: apiData?.authKey || '',
              integrationNumber: apiData?.integratedNumber || '91',
              namespace: apiData?.namespace || '',
              whatsappApiUrl: apiData?.whatsappApiUrl || '',
              billing: apiData?.templates?.billing || '',
              appointment: apiData?.templates?.appointment || '',
              appointmentReminder: apiData?.templates?.appointmentReminder || '',
              birthday: apiData?.templates?.birthday || '',
              anniversary: apiData?.templates?.anniversary || '',
              serviceReminder: apiData?.templates?.serviceReminder || '',
            });
          }
        } catch (error) {
          console.error(error);
        }
      };
      fetchSettings();
    }
  }, [open, data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'integrationNumber') {
      let numericValue = value.replace(/[^0-9]/g, '');
      if (!numericValue.startsWith('91')) {
        numericValue = '91';
      }
      if (numericValue.length > 12) {
        numericValue = numericValue.slice(0, 12);
      }
      setFormData((prev) => ({ ...prev, [name]: numericValue }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async () => {
    setOpen(false);
    setLoading(true);
    try {
      const payload = {
        authKey: formData.authKey,
        integratedNumber: formData.integrationNumber,
        namespace: formData.namespace,
        whatsappApiUrl: formData.whatsappApiUrl,
        isActive: true,
      };
      const templatePayload = {
        billing: formData.billing,
        appointment: formData.appointment,
        appointmentReminder: formData.appointmentReminder,
        birthday: formData.birthday,
        anniversary: formData.anniversary,
        serviceReminder: formData.serviceReminder,
      };
      const [res, resTemplates] = await Promise.all([
        updateMsg91Whatsapp(data._id, payload),
        updateMsg91Whatsapptemplatenames(data._id, templatePayload).catch((err) => {
          console.error('Template update failed:', err);
          return { status: 'error', message: 'Template update failed' };
        }),
      ]);

      if (res?.statusCode == 200 || res?.status === 200 || res?.status === 'success' || res?.success === true) {
        setShowMessage({
          message: 'WhatsApp settings updated successfully',
          messageType: 'success',
        });
        refreshData(data._id);
      } else {
        setShowMessage({
          message: res?.message || 'Failed to update settings',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Something went wrong',
        messageType: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async () => {
    setLoading(true);
    try {
      const res = await resetWhatsappSettings(data._id);
      if (res?.statusCode === 200 || res?.success === true) {
        setFormData({
          authKey: '',
          integrationNumber: '+91',
          namespace: '',
          whatsappApiUrl: '',
          billing: '',
          appointment: '',
          appointmentReminder: '',
          birthday: '',
          anniversary: '',
          serviceReminder: '',
        });
        setShowMessage({
          message: res.message || 'WhatsApp settings reset successfully',
          messageType: 'success',
        });
        refreshData(data._id);
      } else {
        setShowMessage({
          message: res?.message || 'Failed to reset settings',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Something went wrong',
        messageType: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        style={{
          backgroundColor: '#25D366',
          color: 'white',
          fontSize: '16px',
          fontWeight: '600',
          padding: '8px 20px',
          borderRadius: '8px',
          border: 'none',
          boxShadow: '0 4px 15px rgba(37, 211, 102, 0.3)',
          width: '20%',
          marginTop: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
        }}
        onClick={() => setOpen(true)}
      >
        <FaWhatsapp size={20} />
        WhatsApp Integration
      </Button>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
        <DialogContent style={{ padding: 0, overflowX: 'hidden' }}>
          <div
            style={{
              padding: '30px',
              backgroundColor: '#fff',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <Box position="absolute" top={10} right={10} zIndex={2}>
              <IconButton onClick={() => setOpen(false)}>
                <MdClose />
              </IconButton>
            </Box>
            <div
              style={{
                position: 'absolute',
                top: '-50px',
                right: '-50px',
                width: '150px',
                height: '150px',
                borderRadius: '50%',
                backgroundColor: 'rgba(37, 211, 102, 0.1)',
                zIndex: 0,
              }}
            />

            <Box display="flex" alignItems="center" mb={4} position="relative" zIndex={1}>
              <Box
                style={{
                  backgroundColor: '#25D366',
                  borderRadius: '12px',
                  padding: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '18px',
                  boxShadow: '0 4px 12px rgba(37, 211, 102, 0.4)',
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="white"
                >
                  <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.463 1.065 2.876 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
                </svg>
              </Box>
              <Box>
                <Typography
                  variant="h5"
                  style={{ fontWeight: '700', color: '#1a1a1a', letterSpacing: '-0.5px' }}
                >
                  WhatsApp Integration
                </Typography>
              
              </Box>
            </Box>

            <Grid container spacing={2} style={{ position: 'relative', zIndex: 1 }}>
              <Grid item xs={12} md={6}>
                <Box style={{ position: 'relative' }}>
                  <TextInputs
                    title="Auth Key"
                    name="authKey"
                    value={formData.authKey}
                    handleChange={handleChange}
                    type={showAuthKey ? 'text' : 'password'}
                    placeholder="Enter your Auth Key"
                    style={{ marginBottom: '15px', width: '100%' }}
                  />
                  <IconButton
                    onClick={() => setShowAuthKey(!showAuthKey)}
                    style={{ position: 'absolute', right: 12, top: 38, zIndex: 1 }}
                    size="small"
                  >
                    {showAuthKey ? <FaEyeSlash /> : <FaEye />}
                  </IconButton>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box style={{ position: 'relative' }}>
                  <TextInputs
                    title="Integration Number"
                    name="integrationNumber"
                    value={formData.integrationNumber}
                    handleChange={handleChange}
                    type={showIntegrationNumber ? 'text' : 'password'}
                    placeholder="Enter Integration Number"
                    style={{ marginBottom: '15px', width: '100%' }}
                  />
                  <IconButton
                    onClick={() => setShowIntegrationNumber(!showIntegrationNumber)}
                    style={{ position: 'absolute', right: 12, top: 38, zIndex: 1 }}
                    size="small"
                  >
                    {showIntegrationNumber ? <FaEyeSlash /> : <FaEye />}
                  </IconButton>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box style={{ position: 'relative' }}>
                  <TextInputs
                    title="Namespace"
                    name="namespace"
                    value={formData.namespace}
                    handleChange={handleChange}
                    type={showNamespace ? 'text' : 'password'}
                    placeholder="Enter Namespace"
                    style={{ marginBottom: '15px', width: '100%' }}
                  />
                  <IconButton
                    onClick={() => setShowNamespace(!showNamespace)}
                    style={{ position: 'absolute', right: 12, top: 38, zIndex: 1 }}
                    size="small"
                  >
                    {showNamespace ? <FaEyeSlash /> : <FaEye />}
                  </IconButton>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box style={{ position: 'relative' }}>
                  <TextInputs
                    title="WhatsApp API URL"
                    name="whatsappApiUrl"
                    value={formData.whatsappApiUrl}
                    handleChange={handleChange}
                    type={showApiUrl ? 'text' : 'password'}
                    placeholder="Enter WhatsApp API URL"
                    style={{ marginBottom: '15px', width: '100%' }}
                  />
                  <IconButton
                    onClick={() => setShowApiUrl(!showApiUrl)}
                    style={{ position: 'absolute', right: 12, top: 38, zIndex: 1 }}
                    size="small"
                  >
                    {showApiUrl ? <FaEyeSlash /> : <FaEye />}
                  </IconButton>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextInputs
                  title="Billing Template"
                  name="billing"
                  value={formData.billing}
                  handleChange={handleChange}
                  type="text"
                  placeholder="Enter Billing Template"
                  style={{ marginBottom: '15px' }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextInputs
                  title="Appointment Template"
                  name="appointment"
                  value={formData.appointment}
                  handleChange={handleChange}
                  type="text"
                  placeholder="Enter Appointment Template"
                  style={{ marginBottom: '15px' }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextInputs
                  title="Appointment Reminder Template"
                  name="appointmentReminder"
                  value={formData.appointmentReminder}
                  handleChange={handleChange}
                  type="text"
                  placeholder="Enter Appointment Reminder Template"
                  style={{ marginBottom: '15px' }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextInputs
                  title="Birthday Template"
                  name="birthday"
                  value={formData.birthday}
                  handleChange={handleChange}
                  type="text"
                  placeholder="Enter Birthday Template"
                  style={{ marginBottom: '15px' }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextInputs
                  title="Anniversary Template"
                  name="anniversary"
                  value={formData.anniversary}
                  handleChange={handleChange}
                  type="text"
                  placeholder="Enter Anniversary Template"
                  style={{ marginBottom: '15px' }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextInputs
                  title="Service Reminder Template"
                  name="serviceReminder"
                  value={formData.serviceReminder}
                  handleChange={handleChange}
                  type="text"
                  placeholder="Enter Service Reminder Template"
                  style={{ marginBottom: '15px' }}
                />
              </Grid>

              <Grid item xs={12}>
                <Box display="flex" justifyContent="flex-end" mt={2} gap={2}>
                  <Button
                    style={{
                      backgroundColor: '#dc3545',
                      color: 'white',
                      fontSize: '15px',
                      fontWeight: '600',
                      padding: '12px 35px',
                      borderRadius: '8px',
                      border: 'none',
                      boxShadow: '0 4px 15px rgba(220, 53, 69, 0.3)',
                      transition: 'all 0.3s ease',
                      cursor: loading ? 'not-allowed' : 'pointer',
                      textTransform: 'none',
                    }}
                    onClick={handleReset}
                    disabled={loading}
                  >
                    Reset
                  </Button>
                  <Button
                    style={{
                      backgroundColor: '#25D366',
                      color: 'white',
                      fontSize: '15px',
                      fontWeight: '600',
                      padding: '12px 35px',
                      borderRadius: '8px',
                      border: 'none',
                      boxShadow: '0 4px 15px rgba(37, 211, 102, 0.3)',
                      transition: 'all 0.3s ease',
                      cursor: loading ? 'not-allowed' : 'pointer',
                      textTransform: 'none',
                    }}
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {loading ? (
                      <CircularProgress size={24} style={{ color: 'white' }} />
                    ) : (
                      'Save'
                    )}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default WhatsAppIntegration;
